import { useFeatureStaticMenuQuery } from 'generated/sanity-graphql';
import { useFeaturesContext } from 'state/features';

import { IParsedItemUnavailableModalData, IUseFeatureStaticMenu } from './types';
import { parseData, validationKeys } from './utils';

export const useFeatureStaticMenu = (): IUseFeatureStaticMenu => {
  const { featureStaticMenuId = '', featureIdsLoading } = useFeaturesContext();
  const { data, loading } = useFeatureStaticMenuQuery({
    variables: { featureStaticMenuId },
    skip: !featureStaticMenuId
  });

  const featureStaticMenuLoading = featureIdsLoading || loading;
  const itemUnavailableModalData = data?.FeatureStaticMenu?.itemUnavailableModal;

  const itemUnavailableModal = parseData<
    typeof itemUnavailableModalData,
    IParsedItemUnavailableModalData
  >(itemUnavailableModalData, validationKeys.modal);

  return {
    itemUnavailableModal,
    featureStaticMenuLoading
  };
};
